import type React from 'react';
import { EmailSentScreen, type EmailSentScreenProps } from '../email-sent-screen';

export interface SignInLinkSentScreenProps extends Omit<EmailSentScreenProps, 'children'> {
  /** The address the sign-in link was requested for. */
  email: string;
}

/**
 * "Check your email" after asking for a sign-in link, from any page. Worded the same whether or not the address has
 * an account, so it never reveals which.
 */
export const SignInLinkSentScreen: React.FC<SignInLinkSentScreenProps> = ({ email, ...props }) => (
  <EmailSentScreen {...props}>
    <p>
      If there's an account for <strong>{email}</strong>, we've sent a sign-in link.
    </p>
  </EmailSentScreen>
);
